export default {
  message: {
    requestNotFound: '请求不存在',
    requestException: '系统异常',
    requestError: '请求失败',
    requestLoading: '正在加载，请稍后...',
    noData: '暂无数据',
    noPermission: '您没有该功能的权限',
    noTarget: '您没有选中任何对象'
  }
}
